import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Spinner
} from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { addLuckydraw } from "../../store/slices/luckydraw";

export default function AddLuckydraw() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    contributionAmount: "",
    maxParticipants: "",
    maturityAmount: "",
    startDate: ""
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "title":
        if (!value.trim()) {
          error = "Please enter lucky draw title";
        }
        break;



      case "contributionAmount":
        if (!value || Number(value) <= 0) {
          error = "Please enter contribution amount";
        }
        break;

      case "maxParticipants":
        if (!value || Number(value) <= 0) {
          error = "Please enter max participants";
        }
        break;

      case "maturityAmount":
        if (!value || Number(value) <= 0) {
          error = "Please enter maturity amount";
        }
        break;

      case "startDate":
        if (!value) {
          error = "Please select start date";
        }
        break;


      case "drawDate":
        if (!value) {
          error = "Please select draw date";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error
    }));

    return !error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "title") {
      updatedValue = value.replace(/[^a-zA-Z0-9\s_-]/g, "");
    }

    if (
      name === "contributionAmount" ||
      name === "maxParticipants" ||
      name === "maturityAmount"
    ) {
      updatedValue = value.replace(/\D/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue
    }));

    validateField(name, updatedValue);
  };

  const validateForm = () => {
    let valid = true;

    Object.keys(formData).forEach((key) => {
      const fieldValid = validateField(
        key,
        formData[key]
      );

      if (!fieldValid) {
        valid = false;
      }
    });

    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fix validation errors");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        title: formData.title.trim(),
        contributionAmount: Number(
          formData.contributionAmount
        ),
        maxParticipants: Number(
          formData.maxParticipants
        ),
        maturityAmount: Number(
          formData.maturityAmount
        ),
        startDate: new Date(
          formData.startDate
        ).toISOString()
      };

      const response = await dispatch(
        addLuckydraw(payload)
      );

      if (
        response?.payload?.success ||
        response?.meta?.requestStatus === "fulfilled"
      ) {
        toast.success("Lucky draw added successfully");

        setTimeout(() => {
          navigate("/admin/lucky-draw");
        }, 1200);
      } else {
        toast.error(
          response?.payload?.message ||
          "Failed to add lucky draw"
        );
      }
    } catch (error) {
      toast.error(
        error?.message ||
        "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/admin/lucky-draw");
  };

  return (
    <>

      <div className="breadcrumb-bar sticky-top mx-1" >
        <div className="container-fluid">
          <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

            <div className="breadcrumb-left d-flex align-items-center flex-wrap">
              <Link to="/admin/home" className="breadcrumb-link active ">
                Home
              </Link>

              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>
              <Link to="/admin/lucky-draw" className="breadcrumb-link active ">
                Lucky Draw
              </Link>

              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>

              <span
                className="breadcrumb-link inactive"

              >
                Add Lucky Draw
              </span>

            </div>



          </div>
        </div>
      </div>

      <Container fluid className="ld-page">
        <div className="ld-header my-4">
          <h4>Add Lucky Draw</h4>

        </div>

        <Card className="ld-card">
          <Card.Body>

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={3} md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>Title</Form.Label>

                    <input
                      type="text"
                      name="title"
                      className="global-input"
                      placeholder="Enter lucky draw title"
                      value={formData.title}
                      onChange={handleChange}
                      maxLength={40}
                    />

                    {errors.title && (
                      <div className="ld-error">
                        {errors.title}
                      </div>
                    )}
                  </Form.Group>
                </Col>



                <Col lg={3} md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      Contribution Amount
                    </Form.Label>
                    <input
                      type="text"
                      name="contributionAmount"
                      className="global-input"
                      value={formData.contributionAmount}
                      onChange={handleChange}
                      placeholder="1000"
                    />
                  </Form.Group>
                </Col>

                <Col lg={3} md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      Max Participants
                    </Form.Label>
                    <input
                      type="text"
                      name="maxParticipants"
                      className="global-input"
                      value={formData.maxParticipants}
                      onChange={handleChange}
                      placeholder="100"
                    />
                  </Form.Group>
                </Col>

                <Col lg={3} md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      Maturity Amount
                    </Form.Label>
                    <input
                      type="text"
                      name="maturityAmount"
                      className="global-input"
                      value={formData.maturityAmount}
                      onChange={handleChange}
                      placeholder="35000"
                    />
                  </Form.Group>
                </Col>

                <Col lg={3} md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      Start Date
                    </Form.Label>

                    <input
                      type="date"
                      name="startDate"
                      className="global-input"
                      value={formData.startDate}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        {/* Buttons Outside Card */}
        <div className="ld-bottom-actions">
          <button
            type="button"
            className="global-cancel-btn "
            onClick={handleCancel}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="global-submit-btn"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Submitting...
              </>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </Container>
    </>
  );
}